<template>
  <div
    class="serp-banner"
    :class="[
      'serp-banner__position_' + position,
       isMobile ? 'mobile' : ''
       ]">
    <img :src="getImageUrl(imageSrc)" @click="openImageLink">
  </div>
</template>

<script>

import {getImageCdnUrl} from "@/assets/js/utils/get-img-cdn";

export default {
  name: "banner-serp",
  props: {
    position: {
      type: Number,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  methods: {
    openImageLink() {
      window.open(this.link);
    },
    getImageUrl(url) {
      return getImageCdnUrl(url);
    }
  }

}
</script>

<style lang="scss" scoped>
.serp-banner {
  cursor: pointer;

  img {
    box-shadow: 1px 2px 45px rgba(153,153,169,.22);
    border-radius: 12px;
    width: 100%;
    height: 100%;
  }

  &__position {
    &_1,
    &_2,
    &_3,
    &_3,
    &_4,
    &_5 {
      display: none;
    }
  }

  &__double {
    display: none;
  }

  @media (min-width: var.$size-sm) {
    &__position {
      &_2 {
        display: none;
      }
    }
  }

  @media (max-width: var.$size-md) {
    &__position {
      &_2 {
        &.mobile {
          display: block;
          grid-area: 1/1/1/2;
        }
      }

      &_3 {
        &.mobile {
          display: block;
          grid-area: 3/1/3/2;
        }
      }

      &_4 {
        &.mobile {
          display: block;
          grid-area: 5/1/5/2;
        }
      }

      &_5 {
        &.mobile {
          display: block;
          grid-area: 7/1/7/2;
        }
      }
    }
  }

  @media (min-width: var.$size-md) {
    &__position {
      &_3 {
        display: block;
        grid-area: 3 / 1 / 4 / 4;
      }

      &_4,
      &_5 {
        display: block;
        margin: 0 12px;

        &.mobile {
          display: none;
        }
      }
    }

    &__double {
      display: flex;
      grid-area: 5/1/5/4;
      margin: 0 -12px;
      max-height: 156px;
    }

    &.mobile {
      display: none;
    }
  }

  @media (min-width: var.$size-xl) {
    &__position {
      &_1 {
        display: flex;
        width: 276px;
        height: 416px;
        background: black;
        margin-top: 24px;
        border-radius: 16px;
      }

      &_2 {
        display: block;
        grid-area: 1/1/1/1;
      }
    }
  }
}

</style>
